import $ from 'jquery';

let popups = $('.img-popup');

popups.each(function(this: any) {
    var segment = $(this).parents('.tr-segment');
    $(this).insertAfter(segment);
});